import ControlFactory from '@/Factories/ControlFactory';
import ComponentManager from '@/Management/ComponentManager';
import RADApplication from '@/Management/RADApplication';
import UrlLinkViewModel from '@/ViewModels/Controls/UrlLinkViewModel';
import UrlLink from '@/Controls/UrlLink';
import LabelViewModel from '@/ViewModels/Controls/LabelViewModel';
import TextBoxViewModel from '@/ViewModels/Controls/TextBoxViewModel';
import LinkViewModel from '@/ViewModels/Controls/LinkViewModel';
import ImageViewModel from '@/ViewModels/Controls/ImageViewModel';
import LocatorHelper from '@/Utility/LocatorHelper';
import GlobalConfiguration from '@/Management/GlobalConfiguration';

export default class UrlLinkFactory extends ControlFactory {

    private jQueryControl: JQuery;
    private UrlLinkViewModel = ComponentManager.getViewModel<typeof UrlLinkViewModel>('UrlLinkViewModel');
    private UrlLink = ComponentManager.getControl<typeof UrlLink>('UrlLink');
    protected LabelViewModel = ComponentManager.getViewModel<typeof LabelViewModel>('LabelViewModel');
    private TextBoxViewModel = ComponentManager.getViewModel<typeof TextBoxViewModel>('TextBoxViewModel');
    protected LinkViewModel = ComponentManager.getViewModel<typeof LinkViewModel>('LinkViewModel');
    protected ImageViewModel = ComponentManager.getViewModel<typeof ImageViewModel>('ImageViewModel');

    private value: any;

    public constructor(params: any) {
        super(params);
        this.value = this.context.genericObject.getObservable(this.detailViewItem.name);
    }

    /**
     * @override
     */
    control: UrlLink;

    /**
     * @override
     */
    public viewModel: UrlLinkViewModel;

    /**
     * @override
     */
    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.viewModel = this.createViewModel();

        this.control = new this.UrlLink(this.viewModel);

        let tuple = this.control.getTuple();
        this.jQueryControl = tuple.control;

        this.addOverwritableToControl(this.jQueryControl, [this.detailViewItem.name]);
        this.registerDefaultValidation([this.detailViewItem.name]);

        return this.jQueryControl;
    }

    private createViewModel(): UrlLinkViewModel {
        let length = this.detailViewItem.length;
        if (isNaN(length) || length === 0) {
            length = 255;
        }

        return new this.UrlLinkViewModel({
            factory: this,
            showLinkOnly: this.isSummaryViewMode,
            isRequired: this.isRequired,
            isEnabled: this.isEnabled,
            isValid: this.isValid,
            textBox: new this.TextBoxViewModel({
                value: this.value,
                isValid: this.isValid,
                maxLength: length,
                isEnabled: this.isEnabled,
                isFocusable: this.isFocusable,
                tooltip: new this.LabelViewModel({
                    ergName: this.detailViewItem.tooltip
                }),
                invalidationText: this.invalidationText,
                parentLocator: this.locator,
                locator: this.detailViewItem.name
            }),
            link: new this.LinkViewModel({
                image: new this.ImageViewModel({
                    source: GlobalConfiguration.inlineImages.OPEN_URL,
                    alternativeText: new this.LabelViewModel({
                        ergName: 'FACTORY_URLLINK_OPEN_URL'
                    })
                }),
                onClick: () => {
                    let link = this.viewModel.textBox.value();

                    if (link.indexOf('www') === 0) {
                        link = 'http://' + link;
                    }

                    if (link.indexOf('http://') === -1 && link.indexOf('https://') === 1) {
                        link = RADApplication.getInstance().serverUrl + link;
                    }

                    window.open(link, '_blank');
                },
                isFocusable: this.isFocusable,
                isEnabled: this.defineComputed(() => {
                    return this.value() ? true : false;
                }),
                tooltip: new this.LabelViewModel({
                    ergName: 'FACTORY_URLLINK_OPEN_URL'
                }),
                isToolBarLink: true,
                parentLocator: this.locator,
                locator: LocatorHelper.buildLocator(this.detailViewItem.name, 'button.open-link')
            })
        });
    }
}

ComponentManager.setFactory('UrlLink', UrlLinkFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');